import {HttpClient} from '@angular/common/http'
import {Injectable} from '@angular/core'
import {HttpService} from '../@core/http/http.service';
import {action} from 'mobx';
import {CREDENTIALS} from '../shared/consts';
import {LoginResponse} from './login/login.interface';
import {UserStore} from './user.store';

@Injectable({providedIn: 'root'})
export class AuthService {
  private http: HttpService
  private _credentials: any | null
  user: any
  originalUser: any

  constructor(http: HttpClient, public store: UserStore) {
    this.http = http as HttpService
    this.setInitialCredentials()
  }

  setInitialCredentials() {
    const savedCredentials = localStorage.getItem(CREDENTIALS)
    if (savedCredentials) {
      this.setCredentials(JSON.parse(savedCredentials))
    }
  }

  @action async login(user: {login: string, password: string}): Promise<LoginResponse> {
    try {
      const {login, password} = user
      const {user: _user} = await this.http.post('/login', {login, password})
      console.log(_user)
      await this.setCredentials(_user)
      await this.fetchMe()
      this.fetchCore()
      return _user
    } catch (e) {
      throw e
    }
  }

  @action async logout(): Promise<boolean> {
    this.setCredentials()
    return true
  }

  isAuthenticated(): boolean {
    return !!this.credentials
  }

  get credentials(): any | null {
    return this._credentials
  }

  async fetchMe() {
    const credentials: any = localStorage.getItem(CREDENTIALS)
    if (credentials) {
      try {
        const adminUser = await this.store.fetchMe()
        this.user = this.store.getNew(adminUser)
        this.originalUser = this.store.getNew(adminUser)
        // localStorage.setItem(PERSONAL_SETTINGS_LOCAL_STORAGE_KEY, JSON.stringify(this.adminUser.personalSettings))
        return this.user
      } catch (e) {
        this.setCredentials(null)
      }
    }
    return
  }

  fetchCore() {}

  /**
   * Sets the user credentials.
   */
  /**
   * Sets the user credentials.
   */
  private async setCredentials(credentials?: any) {
    this._credentials = credentials || null

    if (credentials) {
      localStorage.setItem(CREDENTIALS, JSON.stringify(credentials))
      this.http.setCredentials(credentials)
    } else {
      localStorage.removeItem(CREDENTIALS)
      this.http.removeCredentials()
    }

    return
  }
}
